/* eslint-disable no-unused-vars */

// import sass files
import '../scss/index.scss';

// import bootstrap files
import * as bootstrap from 'bootstrap';

// router pages
import { router } from './router/router';

router();
